import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import env from 'react-dotenv';
import { useForm, Controller } from "react-hook-form";

// Api methods
import { resendVerifyCode, verifyCode } from '../../api/authentication/verifyCode';

// Components
import Modal from '../../components/Modal';

// Constants
import { HOME } from '../../routing/constants';

const OtpModal = ({onClose}) => {
    const { register, handleSubmit, setError, formState: { errors, isDirty, isValid, isSubmitting }, control } = useForm();
    const [responseData, setResponseData] = useState();
    const [resendResponseData, setResendResponseData] = useState();
    const recaptchaRef = useRef();
    const navigate = useNavigate();

    const onSubmit = async data => {
        try {
            // const captchaToken = await recaptchaRef.current.executeAsync();
            const captchaToken = {};
            if (!captchaToken) return;
            const response = await verifyCode(data?.otp?.join(''), captchaToken);
            setResponseData(response?.data);
            recaptchaRef.current.reset();
        } catch (e) {
            recaptchaRef.current.reset();
            setError("root.serverError", {type: "400"});
        }
    };

    const handleResend = async () => {
        try {
            setResendResponseData({isResending: true});
            // const captchaToken = await recaptchaRef.current.executeAsync();
            const captchaToken = {};
            if (!captchaToken) return;
            const response = await resendVerifyCode(captchaToken);
            setResendResponseData({...response?.data, isResent: true});
            recaptchaRef.current.reset();
        } catch (e) {
            recaptchaRef.current.reset();
            setResendResponseData({isResending: false});
            setError("root.serverError", {type: "400"});
        }
    }

    useEffect(() => {
        if (responseData?.statusCode === 1 && responseData?.token) {
            localStorage.setItem('auth', responseData?.token);
            navigate(HOME);
        }
    }, [navigate, responseData?.statusCode, responseData?.token])
    
    const body = <div>
            <header className="mb-8">
                <p className="text-[15px] text-slate-500">E-poçtunuza göndərilmiş 4 rəqəmli kod ilə təsdiqləyin</p>
            </header>
            <form id="otp-form" onSubmit={handleSubmit(onSubmit)}>
                <ReCAPTCHA ref={recaptchaRef} sitekey={env.GOOGLE_RECAPTCHA_SITE_KEY} size="invisible" hl="az" />
                <div className="flex items-center justify-center gap-3">
                    <Controller
                        control={control}
                        name="otp[0]"
                        render = {()=> (
                            <input
                                {...register("otp[0]", {required: true, pattern: 'd*'})}
                                id="otp[0]"
                                maxLength="1"
                                name="otp[0]"
                                type="text" 
                                className="w-14 h-14 text-center text-2xl font-extrabold text-slate-900 bg-slate-100 border border-transparent hover:border-slate-200 appearance-none rounded p-4 outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="otp[1]"
                        render = {()=> (
                            <input
                                {...register("otp[1]", {required: true, pattern: 'd*'})}
                                id="otp[1]"
                                maxLength="1"
                                name="otp[1]"
                                type="text" 
                                className="w-14 h-14 text-center text-2xl font-extrabold text-slate-900 bg-slate-100 border border-transparent hover:border-slate-200 appearance-none rounded p-4 outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="otp[2]"
                        render = {()=> (
                            <input
                                {...register("otp[2]", {required: true, pattern: 'd*'})}
                                id="otp[2]"
                                maxLength="1"
                                name="otp[2]"
                                type="text" 
                                className="w-14 h-14 text-center text-2xl font-extrabold text-slate-900 bg-slate-100 border border-transparent hover:border-slate-200 appearance-none rounded p-4 outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="otp[3]"
                        render = {()=> (
                            <input
                                {...register("otp[3]", {required: true, pattern: 'd*'})}
                                id="otp[3]"
                                maxLength="1"
                                name="otp[3]"
                                type="text" 
                                className="w-14 h-14 text-center text-2xl font-extrabold text-slate-900 bg-slate-100 border border-transparent hover:border-slate-200 appearance-none rounded p-4 outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
                            />
                        )}
                    />
                </div>
                {errors?.root?.serverError && <div className="text-red-600 mt-2 text-xs">Daxil edilmiş məlumatlar yalnışdır. Zəhmət olmasa, yenidən cəhd edin. Əgər problem təkrarlanarsa bizə info@moydadir.az yazın.</div>}
            </form>
            <div className="text-sm text-slate-500 mt-8">
                E-poçt gəlməyib?&nbsp;
                <button
                    disabled={resendResponseData?.isResending || resendResponseData?.isResent}
                    onClick={handleResend}
                    type="button"
                    className="font-medium text-indigo-500 hover:text-indigo-600 disabled:text-gray-400"

                >
                    {resendResponseData?.isResending ? 'Göndərilir' : resendResponseData?.isResent ? 'Göndərildi' : 'Kodu Yenidən göndər'}
                </button>
            </div>
        </div>

    return <Modal 
        title="OTP kod təsdiq"
        body={body}
        buttons={
            <>
                <button
                    disabled={!isDirty || !isValid || isSubmitting}
                    type="button"
                    onClick={handleSubmit(onSubmit)}
                    className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-gray-400"
                >
                    {isSubmitting && <svg aria-hidden="true" role="status" className="inline w-4 h-4 me-3 my-auto text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                        </svg>}
                    {isSubmitting ? 'Yüklənir...' : 'Təsdiqlə'}
                </button>
                <button onClick={onClose} type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">İmtina</button>
            </>
        }
    />
}

export default OtpModal;